export default "__VITE_ASSET___5XHqiQk__"